// MUI components
import { useEffect, useState, useContext } from 'react'
import { IntakeContext } from '../context/IntakeContext'

import { toast } from 'react-toastify'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormField from 'components/FormField'
import Link from '@mui/material/Link'
import InfoIcon from '@mui/icons-material/Info'
import { IconButton, Tooltip, Fade } from '@mui/material'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'

const OnboardingLeave = () => {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  // add an onSubmit button and call the context function `updateUser`
  // const onSubmit = () => updateUser()
  const onSubmit = () => {
    updateUser()
    toast.info('You have successfully updated your user profile', {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }
  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          Now let's talk about Leave
        </Typography>
      </Box>
      {/* <Typography variant="body2" fontSize={{ xs: '16px', sm: '20px' }}>
        First we need to know your name, phone number, and birthday
      </Typography> */}
      <SoftBox component="form" py={3}>
        <Grid container>
          <Grid item xs={12} mt={2} mb={2}>
            <Typography variant="body1Medium">Annual Leave</Typography>
          </Grid>
          <Grid item xs={12} mb={2}>
            {renderMuiFormField({
              autoFocus: false,
              id: 'currentLeaveBalance',
              label: 'Current Earned Annual Leave Balance',
              placeholder: '100.0',
              inputType: 'floatField',
              value: intakeState.currentLeaveBalance,
              onChange: (currentLeaveBalance) =>
                updateIntakeStateAtKey({ currentLeaveBalance }),
            })}
          </Grid>
          <Grid item xs={12} mt={2} mb={2}>
            <Typography variant="body1Medium">Sick Leave</Typography>
          </Grid>
          <Grid item xs={12}>
            {renderMuiFormField({
              autoFocus: false,
              id: 'currentSickLeaveBalance',
              label: 'Current Sick Leave (Hours)',
              placeholder: '100.0',
              inputType: 'floatField',
              value: intakeState.currentSickLeaveBalance,
              onChange: (currentSickLeaveBalance) =>
                updateIntakeStateAtKey({ currentSickLeaveBalance }),
            })}
          </Grid>
        </Grid>
      </SoftBox>
    </Box>
  )
}

export default OnboardingLeave
